import Request from "./index";

class api {
  // 获取校园简介详情
  static getSchoolIntroduction(id) {
    return Request.get("/base/school/introduction/" + id);
  }

  // 获取学校设置信息
  static getSchoolSetting(id) {
    return Request.get("/base/school/setting/" + id);
  }

  // 获取区域下学校列表
  static getSchoolListPage(data) {
    return Request.get('base/school/under', {
      params: data
    })
  }
}

export default api;
